import { useCallback, useEffect } from 'react'

import { IS_PRODUCTION } from 'interfaces/constants'
import { useAmp } from 'next/amp'
import styled, { CSSProperties } from 'styled-components'

type Props = {
  dataFuse?: string
  className?: string
  style?: CSSProperties
  targeting?: {
    [k: string]: string | string[] | number
  }
  index?: number
}

export const PubliftAd = (props: Props) => {
  const isAmp = useAmp()
  if (isAmp) return <PubliftAdAMP {...props} />

  return <PubliftAdNormal {...props} />
}

export const PubliftAdAMP = ({ dataFuse }: Props) => {
  if (!dataFuse) return null

  return (
    <amp-ad
      layout="fluid"
      height="fluid"
      type="doubleclick"
      data-slot={dataFuse}
      data-multi-size="336x280,320x480,320x100,320x50,300x600,300x250,300x100,300x50"
      data-multi-size-validation="false"
      data-enable-refresh="30"
    />
  )
}

export const PubliftAdNormal = ({
  dataFuse,
  targeting,
  className,
  style,
}: Props) => {
  if (!dataFuse) return null

  if (IS_PRODUCTION) return null

  const getTargetingProps = useCallback(() => {
    const res: {
      [k: string]: string
    } = {}
    targeting &&
      Object.keys(targeting).forEach((k) => {
        if (!k) return
        const value = targeting[k]
        res[`data-targeting-${k.toLowerCase()}`] = Array.isArray(value)
          ? value.join(',')
          : String(value)
      })

    if (typeof document !== 'undefined' && !res['data-targeting-Content_ID']) {
      res['data-targeting-Content_ID'] =
        document.querySelector<HTMLMetaElement>('meta[name="content_id"]')
          ?.content || ''
    }
    return res
  }, [targeting])

  useEffect(() => {
    setTimeout(() => {
      window?.fusetag?.registerAll?.()
    }, 300)
  }, [])

  return (
    <PubliftAdDiv
      data-fuse={dataFuse}
      className={className}
      {...getTargetingProps()}
      style={style}
    />
  )
}

const PubliftAdDiv = styled.div`
  max-width: inherit;
  max-height: inherit;
`
